import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import ProductView from 'components/product/ProductView'
import { BASE_URL } from 'config/constants'
import fetcher from 'lib/fetcher'
import { getAllProducts } from 'lib/getAllProducts'
import { getProductDetail } from 'lib/getProductDetail'
import { setCacheControl } from 'lib/misc'
import { isAbsent, isEmptyArray, isSame } from 'lib/utils'
import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType
} from 'next'

import { ICategory, IProduct } from 'store/api'

export let getServerSideProps = async ({
  req,
  params,
  res,
}: GetServerSidePropsContext) => {
  // Stop from running on client
  let isFirstServerCall = isSame(
    req?.url?.indexOf('/_next/data/'),
    -1
  )

  const emptyProps = {
    title: '',
    description: '',
    keywords: '',
    categorySSR: {} as ICategory,
    productSSR: {} as IProduct,
    productDetailSSR: null
  }

  if (!isFirstServerCall)
    return {
      props: emptyProps,
    }

  let slug = params?.['slug'] as string[] | undefined
  if (isEmptyArray(slug)) return { props: emptyProps, notFound: true }

  let { data: categoryData } = await fetcher<{
    categories: ICategory[]
  }>({
    url: `${BASE_URL}/v1/categories/getall`,
    headers: { lng: 'ru' },
  })

  let category = categoryData?.categories.find((x) =>
    isSame(x.slug, slug![0])
  )
  if (isAbsent(category)) return { props: emptyProps, notFound: true }

  let { products: allProducts } = await getAllProducts('ru')
  let products = allProducts[category.id]
  if (isAbsent(products)) return { props: emptyProps, notFound: true }

  let product = products.find((p) => p.slug === slug![1])
  if (isAbsent(product)) return { props: emptyProps, notFound: true }

  const productDetail = await getProductDetail(product.id)

  if (isAbsent(productDetail))
    return {
      props: emptyProps,
      notFound: true,
    }

  setCacheControl(res)

  return {
    props: {
      title: product.meta.product_title ?? '',
      description: product.meta.product_description ?? '',
      keywords: product.meta.product_keywords ?? '',
      categorySSR: category,
      productSSR: product,
      productDetailSSR: productDetail 
    },
  }
}

export type ProductPageProps = Required<
  InferGetServerSidePropsType<typeof getServerSideProps>
>

let ProductPage: IPage<ProductPageProps> = (props) => (
  <ProductView {...props} />
)

ProductPage.getLayout = (page: { props: ProductPageProps }) => (
  <Layout title={page.props?.title} index withCartPanel>
    {page}
  </Layout>
)

export default ProductPage
